import { useAction } from '@reatom/npm-react'

import { InstantTradeSwapOption } from '../instant-trade-swap-option'

import type { InstantBuyModel } from '@root/widgets/instant-trade-dialog/atoms/reatom-instant-buy'
import type BigNumber from 'bignumber.js'

type Props = {
  model: InstantBuyModel
  amount: BigNumber
}
export const InstantTradeQuickButtonBuy = ({ model, amount }: Props) => {
  const executeBuy = useAction(model.quickBuyAction)

  return (
    <InstantTradeSwapOption
      swapDirection={'buy'}
      title={amount.toNumber()}
      onClick={() => {
        executeBuy(amount)
      }}
    />
  )
}
